import { Transporter } from './transporter.model';

export interface ITransportIncidentItem {
  id?: number;
  name?: string | null;
  transporter?: Transporter | null;
}

export class TransportIncidentItem implements ITransportIncidentItem {
  constructor(public id?: number, public name?: string | null, public transporter?: Transporter | null) {}
}

export function getTransportIncidentItemIdentifier(transportIncidentItem: ITransportIncidentItem): number | undefined {
  return transportIncidentItem.id;
}
